export default "__VITE_ASSET__DeyAUyqf__"